import { useState } from "react";

import { exportTableToXlsx, type XlsxTable } from "@app/lib/export-xlsx";

// The "Export to Excel" button shared by the data screens. `build` assembles the
// grid lazily, at click time, from whatever the page is currently showing — so
// the file reflects the active year/filters/expand state, not a stale snapshot.
export default function ExportToExcelButton({
  build,
  className,
  label = "Export to Excel",
}: {
  build: () => XlsxTable;
  className?: string;
  label?: string;
}) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await exportTableToXlsx(build());
    } catch {
      window.alert("Could not export to Excel — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      title="Download this table as an Excel (.xlsx) file"
      className={
        className ??
        "px-2 py-1 rounded border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-40 text-sm whitespace-nowrap"
      }
    >
      {busy ? "Exporting…" : label}
    </button>
  );
}
